import { actions, types } from './requests'
export const GETCATEGORYLIST_TYPES = {
    ...types('GETCATEGORYLIST'),
}
export const GETCATEGORYLIST_ACTIONS = {
    ...actions('GETCATEGORYLIST'),
}
